import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useVehiclePaymentTerms } from '~/context/vdp/UserVehicleContext';
import useShowTradeIncentivesCopy from '~/hooks/common/selectors/useShowTradeIncentivesCopy';
import useFireTradeIncentiveEvents from '~/hooks/common/telemetry/useFireTradeIncentiveEvents';

export default function useSendTradeIncentiveEvents() {
  const vehiclePricing = useVehiclePaymentTerms();
  const { showTaxSavings, showTradeIncentive } =
    useShowTradeIncentivesCopy(vehiclePricing);

  const fireEvent = useFireTradeIncentiveEvents();

  useEffectOnce(
    () => {
      fireEvent('vdp');
    },
    [fireEvent],
    showTaxSavings || showTradeIncentive
  );
}
